import {AsyncPipe} from '@angular/common'
import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './common/header/header.component'
import {PdfViewerComponent} from './common/pdf-viewer/pdf-viewer.component'
import {ConfigService} from './services/config.service'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrl: 'app.component.scss',
  imports: [
    RouterOutlet,
    AsyncPipe,
    HeaderComponent,
    FooterComponent,
    PdfViewerComponent
  ]
})
export class AppComponent {
  public version = version.version
  public copyrightYears = `2024-${new Date().getFullYear()}`
  public configService = inject(ConfigService)
}
